export function Header() {
  return `
    <header class="site-header">
      <div class="container">
        <div class="header-content">
          <a href="/master" class="site-logo">
            <h1>反響成約マスター</h1>
          </a>
          
          <button class="menu-toggle" onclick="toggleMobileMenu()" aria-label="メニュー">
            <span></span>
            <span></span>
            <span></span>
          </button>
          
          <nav class="header-nav">
            <a href="/">ホーム</a>
            <a href="/master">反響成約マスター</a>
            <a href="/master/lab">反響成約ラボ</a>
            <a href="/master/download">資料ダウンロード</a>
          </nav>
        </div>
      </div>
    </header>
  `;
}